import { can } from '@hrms/shared'
import { LuPlus } from 'react-icons/lu'
import { useCurrentUser } from '../../../auth/AuthProvider.tsx'
import { Button } from '../../../components/ui/index.ts'
import { hint } from '../../../lib/hint.ts'
import { RaiseTicketModal } from './RaiseTicketModal.tsx'
import { openRaiseTicket, useRaiseTicketState } from './raiseStore.ts'

/** Top-bar "+ Raise a ticket" (icon only on small screens) plus the modal it opens. */
export function RaiseTicketButton() {
  const user = useCurrentUser()
  const state = useRaiseTicketState()
  if (!can(user, 'ticket.create.self')) return null
  return (
    <>
      <Button
        variant="primary"
        onClick={() => openRaiseTicket()}
        aria-label="Raise a ticket"
        data-tour="raise-ticket"
        className="max-[720px]:w-8.5 max-[720px]:px-0"
        {...hint('Ask HR for help with leave, payroll, reimbursements and more')}
      >
        <LuPlus aria-hidden className="size-4" />
        <span className="max-[720px]:hidden">Raise a ticket</span>
      </Button>
      {state && <RaiseTicketModal options={state} />}
    </>
  )
}
